var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
import { spacing } from '../../theme/spacing';
import { typography } from '../../theme/typography';
var PageWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  margin: ", " ", ";\n  font-family: ", ";\n"], ["\n  width: 100%;\n  margin: ", " ", ";\n  font-family: ", ";\n"])), spacing.l, spacing.s, typography);
var DualButton = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n"], ["\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n"])));
export { DualButton, PageWrapper };
var templateObject_1, templateObject_2;
